import { ReactElement } from 'react';
import { usePageViewAnalytics } from '@client/analytics/hooks';
import { TEALIUM_PAGE_TYPE } from '@client/analytics/types/types';
import { Page } from '@client/app/components/App/Page';
import { useTranslate } from '@client/i18n/hooks';
import { AccountMenu } from 'b2b-components/theme/components/AccountMenu';
import { Dropdown } from 'b2b-components/theme/components/AccountMenu/Dropdown';
import { useDeviceType } from 'b2b-apps/core/common/hooks';
import { useMyAccountDashboardLinks } from 'b2b-apps/core/myAccount/common/hooks';
import { useRouterPush } from 'b2b-apps/core/routes/hooks';
import { openLink } from 'b2b-apps/core/routes/utils/url';
import { Props } from './MyAccount.types';
import './MyAccount.scss';

export const MyAccount = ({ children, active }: Props): ReactElement => {
  const t = useTranslate();

  const push = useRouterPush();
  const myAccountDashboardLinks = useMyAccountDashboardLinks(active);
  const deviceType = useDeviceType();

  const handleLinkClick = (url: string) => openLink(url, push);

  usePageViewAnalytics({
    pageType: TEALIUM_PAGE_TYPE.account,
  });

  return (
    <Page className='MyAccount' title={t('Account dashboard')}>
      <section className='MyAccount-Menu'>
        <AccountMenu
          groups={myAccountDashboardLinks}
          onLinkClick={handleLinkClick}
          className='MyAccount-MenuDesktop'
          border={true}
        />

        <Dropdown
          label={t('My account menu')}
          deviceType={deviceType}
          groups={myAccountDashboardLinks}
          onLinkClick={handleLinkClick}
          className='MyAccount-MenuMobile'
        />
      </section>

      <section className="MyAccount-Content">{children}</section>
    </Page>
  );
};
